// extracted by mini-css-extract-plugin
export var buttonContainer = "_9a-1";
export var fontSizeSelect = "_9a-3";
export var formatSelect = "_9a-2";
export var formats = "_9a-4";
export var hidden = "_9a-5";
export var icon = "_9a-6";
export var select = "_9a-0";